import { RefreshCw, Unplug } from "lucide-react";

interface ErrorPanelProps {
  title: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  fullPage?: boolean;
}

export function ErrorPanel({
  title,
  message,
  actionLabel,
  onAction,
  fullPage = false,
}: ErrorPanelProps) {
  return (
    <section
      className={`error-panel${fullPage ? " error-panel--full" : ""}`}
      role="alert"
    >
      <span className="error-panel__icon" aria-hidden="true">
        <Unplug />
      </span>
      <div>
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
      {actionLabel && onAction && (
        <button type="button" className="button button--secondary" onClick={onAction}>
          <RefreshCw aria-hidden="true" />
          {actionLabel}
        </button>
      )}
    </section>
  );
}
